import type { CommerceStep } from '@/types/CommerceStep'

/**
 * The step whose route is `path`. Pass `route.path`, not `route.fullPath`: `routeUrl` comes from
 * `router.resolve().href` and carries no query, so a query on the URL (UTM tags from a marketing
 * link) would leave the step unmatched.
 */
export function commerceStepAtPath(steps: CommerceStep[], path: string): CommerceStep | undefined {
  return steps.find((step) => step.routeUrl === path)
}

/** The step after `step` in `steps`, or `undefined` when `step` is last or not in the list. */
export function commerceStepAfter(
  steps: CommerceStep[],
  step: CommerceStep | undefined
): CommerceStep | undefined {
  if (!step) return undefined

  const index = steps.findIndex((s) => s.id === step.id)
  return index === -1 ? undefined : steps[index + 1]
}
